<template>
  <div class="school-manage">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>学校管理</span>
        <div class="header-buttons">
          <el-button type="primary" @click="showAddDialog" icon="el-icon-plus">添加</el-button>
          <el-button type="success" @click="refreshList" icon="el-icon-refresh">刷新</el-button>
        </div>
      </div>

      <!-- 学校列表 -->
      <el-table :data="schoolList" style="width: 100%;" v-loading="tableLoading">
        <el-table-column prop="name" label="学校名称" min-width="120"/>
        <el-table-column prop="english" label="英文缩写" min-width="100"/>
        <el-table-column label="操作" width="220" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="info" @click="viewSchoolRecords(scope.row.id)">
              查看记录
            </el-button>
            <el-button size="mini" type="danger" @click="deleteSchool(scope.row.id)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 添加学校弹窗 -->
    <el-dialog title="添加学校" :visible.sync="addDialogVisible" width="500px" @close="resetForm">
      <el-form :model="form" :rules="rules" ref="schoolForm" label-width="100px">
        <el-form-item label="学校名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入学校名称"></el-input>
        </el-form-item>
        <el-form-item label="英文缩写" prop="english">
          <el-input v-model="form.english" placeholder="请输入学校英文缩写"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="addSchool" :loading="loading">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'SchoolManage',
  data() {
    return {
      loading: false,
      tableLoading: false,
      addDialogVisible: false,
      form: {
        name: '',
        english: ''
      },
      rules: {
        name: [
          {required: true, message: '请输入学校名称', trigger: 'blur'},
          {min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur'}
        ],
        english: [
          {required: true, message: '请输入英文缩写', trigger: 'blur'},
          {min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur'}
        ]
      },
      schoolList: []
    }
  },
  created() {
    this.getSchoolList()
  },
  methods: {
    // 显示添加弹窗
    showAddDialog() {
      this.addDialogVisible = true
    },
    // 刷新列表
    refreshList() {
      this.getSchoolList()
    },
    // 添加学校
    addSchool() {
      this.$refs.schoolForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          try {
            const {data: res} = await this.$http.post('/api/school/add', this.form)
            if (res.status !== 0) return this.$message.error('添加失败')
            this.$message.success('添加成功')
            this.addDialogVisible = false
            this.resetForm()
            this.getSchoolList()
          } catch (error) {
            this.$message.error('添加失败')
          } finally {
            this.loading = false
          }
        }
      })
    },
    // 获取学校列表
    async getSchoolList() {
      this.tableLoading = true
      try {
        const {data: res} = await this.$http.get('/api/school/list')
        if (res.status !== 0) return this.$message.error('获取学校列表失败')
        this.schoolList = res.data
      } catch (error) {
        this.$message.error('获取学校列表失败')
      } finally {
        this.tableLoading = false
      }
    },
    // 删除学校
    deleteSchool(id) {
      this.$confirm('此操作将永久删除该学校及其相关记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const {data: res} = await this.$http.delete(`/api/school/delete/${id}`)
          if (res.status !== 0) return this.$message.error('删除失败')
          this.$message.success('删除成功')
          this.getSchoolList()
        } catch (error) {
          this.$message.error('删除失败')
        }
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    // 重置表单
    resetForm() {
      this.$refs.schoolForm.resetFields()
    },
    // 跳转到巡检记录页面，按school_id筛选
    viewSchoolRecords(schoolId) {
      this.$router.push({
        path: '/inspectionmanage',
        query: {school_id: schoolId}
      })
      this.$nextTick(() => {
        window.sessionStorage.setItem('activePath', '/inspectionmanage')
      })
    }
  }
}
</script>

<style scoped>
.school-manage {
  padding: 20px;
}
.box-card {
  margin-bottom: 20px;
}
.header-buttons {
  float: right;
}
.header-buttons .el-button {
  margin-left: 10px;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}
</style>